import React, { useEffect, useState } from "react";
import { can_visit, getPractice, notify } from "../../../helpers";
import { getOtpSettings, setupOTP } from "../../../services/users";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import Spacing from "../../Spacing";
import OtpConfirmationModal from "../../Modal/OtpConfirmationModal";

export default function SetupOTPPage({selectedPracticeChange, fetchChangePracticeData}) {
  const [enableOtpConfirmation, setEnableOtpConfirmation] = useState(false);
  const [enableOtpConfirmationLoader, setEnableOtpConfirmationLoader] = useState(false);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  
  let account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    account_id = selectedPracticeChange?.account_id;
  }
  const [informations, setInformations] = useState({
    account_id: account_id,
    otp_bool: "",
  });

  const [pendingOtpChange, setPendingOtpChange] = useState(null);

  const handleOTPChange = async (value) => {
    if(can_visit("settings_otp_setup")) {
      setEnableOtpConfirmationLoader(true);
      try {
        const result = await setupOTP({ ...informations, otp_bool: value });

        if(result.data.status === "error") {
          notify("error", result?.data?.message);
        } else {
          notify("success", result?.data?.message);
          setInformations({ ...informations, otp_bool: value });
          setEnableOtpConfirmation(false);
          window.scrollTo(0, previousScrollPosition);
        }
      } catch (error) {
        notify("error", "Error setting up OTP");
      } finally {
        setEnableOtpConfirmationLoader(false);
      }
    }
  };

  useEffect(() => {
    const fetchOtpSettings = async () => {
      const data = await getOtpSettings();
      if (data?.data) {
        setInformations({
          ...informations,
          otp_bool: data?.data?.otp_bool?.toString(),
        });
      }
    };
    fetchOtpSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSwitchChange = (e) => {
    const newValue = e.target.checked ? "true" : "false";

    if (newValue === "true") {
      setPendingOtpChange(newValue);
      setEnableOtpConfirmation(true);
      setPreviousScrollPosition(window.scrollY);
      window.scrollTo(0, 0);
    } else {
      handleOTPChange(newValue);
    }
  };

  const handleOTPEnableConfirm = async (id) => {
    if (pendingOtpChange) {
      handleOTPChange(pendingOtpChange);
      setPendingOtpChange(null);
    }
    setEnableOtpConfirmation(false);
    window.scrollTo(0, previousScrollPosition);
  };

  useDocumentTitle("2FA Verification");

  return (
    <>
      <div className='docpro_border_heading_card card_700'>
        <div className="card_heading">
          <h1 className="mb-0 docpro_fs_18">2FA Setup</h1>
        </div>

        <div className="card_body">
          <div className="docpro_mode_toggle">
            <h6 className="fw-500 primary-color mb-0"> Two-Step Verification : </h6>
            <label className="switch switch_mode mb-0">
              <input
                type="checkbox"
                name="otp_bool"
                className="docpro_logo_color"
                checked={informations.otp_bool === "true"}
                onChange={handleSwitchChange}
              />
              <span className="slider"></span>
            </label>
          </div>
          
          <Spacing lg="18" sm="18" />
          <p className="docpro_fs_14 docpro_mb_0">
            {informations.otp_bool === "true" ? 
              <span className="docpro_green_color">Two-Step Verification is enabled. You must log in using both your password and an OTP code.</span>
              : 
              <span className="docpro_red_color">Two-Step Verification is disabled. You can log in with just your password.</span> 
            }
          </p>
        </div>
      </div>

      {enableOtpConfirmation && (
        <OtpConfirmationModal
          actionType={handleOTPEnableConfirm}
          openModal={enableOtpConfirmation}
          setOpenModal={setEnableOtpConfirmation}
          enableOtpConfirmationLoader={enableOtpConfirmationLoader}
          sendFrom="otp"
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}